export function formatBalance(value: number): string {
    if (value >= 10_000_000) {
        return `${(value / 1_000_000).toFixed(1)}M`;
    } else if (value >= 1_000_000) {
        return `${(value / 1_000_000).toFixed(2)}M`;
    } else if (value >= 100_000) {
        return `${(value / 1_000).toFixed(1)}K`;
    } else if (value >= 1_000) {
        return `${(value / 1_000).toFixed(2)}K`;
    } else {
        return value.toFixed(2).toString();
    }
}

export function formattedToTwoDecimals(value: number | '-' | null): string {
    return Number(Math.floor(Number(`${value}e2`)) + 'e-2').toFixed(2);
}
